import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}>
      <div className="stack gap-3" style={{ alignItems: 'center', textAlign: 'center' }}>
        <ShieldAlert size={40} color="var(--text-tertiary)" />
        <div className="h2-section">404 — Page not found</div>
        <p className="body-text">The page you're looking for doesn't exist, or the permit may have moved.</p>
        <Link to="/" className="btn btn-primary" style={{ marginTop: 8 }}>Return home</Link>
      </div>
    </div>
  );
}
